// Recovered compiled webpack factory 15824. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { Uu: () => r });
  var n = i(40031);
  let s = "undefined" != typeof window;
  function r() {
    if (((n.r.current = !0), s))
      if (window.matchMedia) {
        let t = window.matchMedia("(prefers-reduced-motion)"),
          e = () => (n.O.current = t.matches);
        (t.addEventListener("change", e), e());
      } else n.O.current = !1;
  }
}
